import React, { useState } from "react";
import * as XLSX from "xlsx";
import apiClient from "./api/apiClient";
import {
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const BankVerificationImport = () => {
  const [data, setData] = useState([]);

  const handleFileUpload = (e) => {
    const uploadedFile = e.target.files[0];

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      setData(jsonData);
    };
    reader.readAsBinaryString(uploadedFile);
  };

  const handleUploadToServer = async () => {
    try {
      const mappedData = data.map((row) => ({
        caseId: row["VB Number"] || "",
        checkId: row["Check Id"] || "",
        employmentType: row["Emp Type"] || "",
        clientName: row["Client Name"] || "",
        candidateName: row["Candidate Name"] || "",
        companyName: row["Company Name"] || "", 
        mobilePhoneNumber: row["Mobile Phone Number"] || "",
        email: row["Email"] || "",
        tenureFrom: row["Tenure From"] ? new Date(row["Tenure From"]) : null,
        tenureTo: row["Tenure To"] ? new Date(row["Tenure To"]) : null,
        assignedByEmpExec:row["Assigned By Emp Executive"] || "",
        bsInitiationDate:row["BS Initiation Date"] ? new Date(row["BS Initiation Date"]) : null
      }));

      let response = await apiClient.post("/bankverifications/import", mappedData);
      alert("Data uploaded successfully!");
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Check console for details.");
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Import Bank Verification Data
      </Typography>

      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />

      {data.length > 0 && (
        <>
          <Box mt={3}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    {Object.keys(data[0]).map((key) => (
                      <TableCell key={key} sx={{ fontWeight: "bold" }}>
                        {key}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((row, i) => (
                    <TableRow key={i}>
                      {Object.values(row).map((val, j) => (
                        <TableCell key={j}>{val}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box mt={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleUploadToServer}
            >
              Import
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default BankVerificationImport;
